import type { CSSProperties } from 'react';

/**
 * Each sidebar page icon's own three colours, for the ring and glow round
 * the selected tile in the Candy style. Keyed by the sidebar's icon names.
 */
const GLOW: Record<string, [string, string, string]> = {
  house: ['#FF6B4A', '#FF9A3C', '#62D2F5'],
  'user-magnifying-glass': ['#7C5CFF', '#A893FF', '#7DF1E5'],
  robot: ['#3B5AF7', '#E0529C', '#EE7B34'],
  'list-bullets': ['#FF5D9E', '#FFC93C', '#8FD3FF'],
  'paper-plane-top': ['#1D4FD8', '#2F80FF', '#A7D3FF'],
  'paper-plane-clu': ['#1D4FD8', '#2F80FF', '#A7D3FF'],
  inbox: ['#0D9F87', '#16C7A6', '#FF7EB6'],
  'list-check': ['#FFB547', '#21C45D', '#7A5AF8'],
  'puzzle-piece': ['#8B5CF6', '#FF8A3D', '#FFC59B'],
  'chart-user': ['#FF6FAE', '#FFC23D', '#4D7CFF'],
  'address-book': ['#27B24A', '#74D98A', '#FFD23F'],
  buildings: ['#B44CE6', '#F27BC9', '#FFD23F'],
  gear: ['#7C8DB5', '#5FD3F5', '#E9EDF7'],
  // The folded rail's section cells.
  'bullseye-arrow': ['#FF6FAE', '#FFC23D', '#7C5CFF'],
  envelope: ['#FFBE2E', '#F59A0B', '#FF4D94'],
  bolt: ['#FF7A1A', '#FFB020', '#FFD966'],
};

/**
 * A sidebar tile's attributes for the Candy style's selected ring and glow
 * (candy-tile.css): its icon's colours and its corner radius. Nothing for an
 * icon without colours (an agent's mark, a chat). The CSS applies only in the
 * Candy style, so they are harmless in Plain.
 */
export function candyTileProps(
  iconName: string | undefined,
  radius: number
): { 'data-candy-tile'?: ''; style?: CSSProperties } {
  const glow = iconName ? GLOW[iconName] : undefined;
  if (!glow) return {};
  return {
    'data-candy-tile': '',
    style: {
      '--g1': glow[0],
      '--g2': glow[1],
      '--g3': glow[2],
      '--tile-radius': `${radius}px`,
    } as CSSProperties,
  };
}
